import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
// import Logo from '../../images/Logo/logo-big.png'
import Logo from '../../images/Logo/logo-white-bg.png'
import Error from '../../components/404';



const ErrorPage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-header-style-3'} Logo={Logo} />
            <Error />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default ErrorPage;
